// import React from "react";
// import { TrueCloudContent } from "../Components/TrueCloudContent";

// const TrueCloud = () => {
//   return <TrueCloudContent />;
// };

// export default TrueCloud;
import React from "react";
import { TrueCloudContent } from "../Components/TrueCloudContent";
import SEO from "../../../../global/components/SEO/SEO";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";

const TrueCloud = () => {
  const seoData = getSEOData("/true-cloud");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <div>
        <TrueCloudContent />
      </div>
    </>
  );
};

export default TrueCloud;
